import { RouteConfig } from "vue-router"

/**
 * RouteConfigを定義します: [CsvNegative]。
 */
export const CsvNegativeRouteConfig: RouteConfig = {
  path: "/CsvNegative",
  name: "CsvNegative",
  component: () => import("%%/views/csvNegative/CsvNegative.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
